import { getSiteLocation } from 'aos-config-loader'
import { values } from 'lodash'

const siteLocations = getSiteLocation()

const customRoles = siteLocations.customRoles

// Custom roles (e.g. ApocTllUser) are merged from siteLocation at runtime.
// The index signature allows accessing customer-specific keys like Role.ApocTllUser.
export const Role: Record<string, string> = {
    User: 'USER',
    ApocUser: 'UNIT_APOC',
    AirportServiceUser: 'UNIT_AIRPORT_SERVICES',
    EquipmentMaintenanceUser: 'UNIT_EQUIPMENT_MAINTENANCE',
    ApronServicesUser: 'UNIT_APRON_SERVICES',
    ApronControlUser: 'UNIT_APRON_CONTROL',
    RescueServiceUser: 'UNIT_RESCUE_SERVICE',
    AviationElectricityUser: 'UNIT_AVIATION_ELECTRICITY',
    SecurityServicesUser: 'UNIT_SECURITY_SERVICES',
    AirfieldMaintenanceUser: 'UNIT_AIRFIELD_MAINTENANCE',
    FacilityMaintenanceUser: 'UNIT_FACILITY_MAINTENANCE',
    CorporateIMServicesUser: 'UNIT_CORPORATE_IM_SERVICES',
    CommunicationUser: 'UNIT_COMMUNICATION',
    EventCommander: 'EVENT_COMMANDER',
    CommercialBusinessUnit: 'UNIT_COMMERCIAL_BUSINESS',

    AosAdmin: 'AOS_ADMIN',
    AosUserAdmin: 'AOS_USERADMIN',
    EventAdmin: 'EVENT_ADMIN',
    TaskAdmin: 'TASK_ADMIN',
    FodAdmin: 'FOD_ADMIN',
    ...siteLocations.customRoles,
}
export type Role = (typeof Role)[keyof typeof Role]

export const UnitRoles = [
    Role.ApocUser,
    Role.AirportServiceUser,
    Role.EquipmentMaintenanceUser,
    Role.ApronServicesUser,
    Role.ApronControlUser,
    Role.RescueServiceUser,
    Role.AviationElectricityUser,
    Role.SecurityServicesUser,
    Role.AirfieldMaintenanceUser,
    Role.FacilityMaintenanceUser,
    Role.CorporateIMServicesUser,
    Role.CommunicationUser,
    ...values(customRoles),
]
